import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FadeUp, SectionHeading } from "@/components/Reveal";
import { FAQS } from "@/data/content";

const isHindi = (s) => /[\u0900-\u097F]/.test(s);

export default function FAQ({ className = "" }) {
  return (
    <section className={className} data-testid="faq-section">
      <SectionHeading overline="FAQ — अक्सर पूछे जाने वाले सवाल" lines={["Straight", "answers."]} testId="faq-heading" />
      <FadeUp delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 border-t border-white/10" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className={`py-6 text-left text-base text-paper hover:no-underline hover:text-saffron sm:text-lg [&>svg]:text-saffron ${isHindi(f.q) ? "font-hindi" : "font-display font-semibold uppercase tracking-tight"}`}>
                <span className="flex items-start gap-4">
                  <span className="mt-1 font-mono text-xs text-brand">{String(i + 1).padStart(2, "0")}</span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className={`pb-6 pl-10 text-sm leading-relaxed text-zinc-400 sm:text-base ${isHindi(f.a) ? "font-hindi text-base sm:text-lg" : ""}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </FadeUp>
    </section>
  );
}
